import apiClient from "../api/apiClient";
import API_CONFIG from "../config/api";

export type FeedbackStatus = "new" | "in_progress" | "done";
export interface FeedbackItem {
  id: number;
  user_id: number;
  company_id: number;
  warehouse_id: number | null;
  author_name: string;
  company_name: string;
  warehouse_name: string | null;
  screen_path: string;
  message?: string;
  message_preview?: string;
  status: FeedbackStatus;
  version: number;
  created_at: string;
  updated_at: string;
}
export interface FeedbackList {
  data: FeedbackItem[];
  total: number;
  page: number;
  page_size: number;
}

// La réception est une ressource système globale, isolée par session SysAdmin.
// Ces valeurs ne demandent jamais une entreprise ou un établissement à l'API.
export const feedbackInboxScope = (userId: number | string | null | undefined) => ({
  userId, companyId: "system", warehouseId: "all", moduleScope: "feedback",
});

export async function loadFeedback(params: { page: number; page_size: number; status: string; search: string }, signal: AbortSignal) {
  const response = await apiClient.get(API_CONFIG.apiUrl("/feedback"), { params, signal });
  return response.data as FeedbackList;
}
export async function loadFeedbackDetail(id: number, signal: AbortSignal) {
  const response = await apiClient.get(API_CONFIG.apiUrl(`/feedback/${id}`), { signal });
  return response.data.data as FeedbackItem;
}
export function feedbackError(error: unknown) {
  const data = (error as { response?: { data?: { message?: string; code?: string } } } | null)?.response?.data;
  return { code: data?.code, message: data?.message || "La connexion a échoué. Votre saisie est conservée ; vous pouvez réessayer." };
}

const screenNames: Record<string, string> = {
  accueil: "Accueil", "gestion-ventes": "Ventes", "gestion-achats": "Achats",
  "gestion-produits": "Produits", "gestion-entites": "Clients et fournisseurs",
  "gestion-charges-admin": "Dépenses", "gestion-tresorerie": "Trésorerie",
  "gestion-pos": "Caisse", production: "Production", logistics: "Logistique",
  logistique: "Logistique", hotellerie: "Hôtellerie", hr: "Ressources humaines",
  "gestion-ecommerce": "E-commerce", "retours-utilisateurs": "Retours utilisateurs",
  support: "Support", notifications: "Notifications",
};
export function feedbackScreenName(path: string) {
  const section = path.split("/")[1];
  return screenNames[section] || path;
}

export function newFeedbackRequestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
